"use strict";
/**
 * api 와 web 패키지에서 공통으로 사용하는 상수 정의
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.REDIRECT_FROM_APP = void 0;
// sdk 호출 시 어뷰저 모달 노출을 위해 web 으로 리다이렉트 필요한 경우 사용
exports.REDIRECT_FROM_APP = 'redirectFromApp';
// 지도앱에서 sdk 호출했는지 여부 (5.32.0 부터) - web에서 미사용 중
// export const FROM_NMAP_MY = 'fromNmapMy'
